import { useState } from "react"

import { ViewBarContext } from "./ViewBar.context"
import styles from "./ViewBar.module.scss"
import { ViewBarEndProps, ViewBarRootProps, ViewBarStartProps } from "./ViewBar.types"
import ViewBarPhase from "./ViewBarPhases/ViewBarPhase"
import ViewBarPhases from "./ViewBarPhases/ViewBarPhases"
import ViewBarPortal from "./ViewBarPortal/ViewBarPortal"
import ViewBarSearchButton from "./ViewBarSearchButton/ViewBarSearchButton"
import ViewBarTab from "./ViewBarTabs/ViewBarTab"
import ViewBarTabs from "./ViewBarTabs/ViewBarTabs"
import ViewBarVerticalDivider from "./ViewBarVerticalDivider/ViewBarVerticalDivider"
import ViewBarViewMenuButton from "./ViewBarViewMenuButton/ViewBarViewMenuButton"

function ViewBarRoot(props: ViewBarRootProps) {
    const { children } = props
    const [viewBarRef, setViewBarRef] = useState<HTMLDivElement | null>(null)

    return (
        <ViewBarContext.Provider value={{ viewBarRef, setViewBarRef }}>
            <div ref={setViewBarRef}>
                <div className={styles.root}>{children}</div>
            </div>
        </ViewBarContext.Provider>
    )
}

function ViewBarStart(props: ViewBarStartProps) {
    const { children } = props

    return <div className={styles.start}>{children}</div>
}

function ViewBarEnd(props: ViewBarEndProps) {
    const { children } = props

    return <div className={styles.end}>{children}</div>
}

const Root = ViewBarRoot
const Start = ViewBarStart
const End = ViewBarEnd
const Phases = ViewBarPhases
const Phase = ViewBarPhase
const Tabs = ViewBarTabs
const Tab = ViewBarTab
const VerticalDivider = ViewBarVerticalDivider
const SearchButton = ViewBarSearchButton
const ViewMenuButton = ViewBarViewMenuButton
const Portal = ViewBarPortal

export default {
    Root,
    Start,
    End,
    Phases,
    Phase,
    Tabs,
    Tab,
    VerticalDivider,
    SearchButton,
    ViewMenuButton,
    Portal,
}
